import { disableScroll, enableScroll } from "../_helpers";

import gsap from "gsap";

class MobileMenu {
  private readonly burger: HTMLButtonElement;
  private readonly closeBtns: HTMLButtonElement[];
  private readonly blackout: HTMLElement;

  constructor(private readonly menuRoot: HTMLElement) {
    this.burger = document.querySelector(".burger.open-menu") as HTMLButtonElement;
    this.closeBtns = [...document.querySelectorAll<HTMLButtonElement>(".close-menu")];
    this.blackout = document.querySelector("#mobile-blackout") as HTMLElement;
  }

  init = async () => {
    this.initBurgerEvents();
    this.initTopLevelEvents();
    this.initTopLevelSubmenu();
    this.initTopLevelBackButtons();
    this.initShowSubmenuButtons();
    this.initBackButtons();
  };

  initBurgerEvents = () => {
    this.burger.addEventListener("click", this.openMenu);
  };

  initTopLevelEvents = () => {
    this.closeBtns.forEach((item) => item.addEventListener("click", this.hideMenu));
    this.blackout.addEventListener("click", this.hideMenu);
  };

  initTopLevelSubmenu = () => {
    const topLevelItems = this.menuRoot.querySelectorAll<HTMLElement>("#default-navigation-list > li.has-children");

    topLevelItems.forEach((item: HTMLElement) => {
      const button = item.querySelector("button") as HTMLButtonElement;
      const submenu = item.querySelector(".submenu-wrapper") as HTMLElement;

      button.addEventListener("click", () => {
        submenu.classList.add("top-level-slide-in");
        gsap.to(submenu, { duration: 0.2, translateX: "0%" });
      });
    });
  };

  initTopLevelBackButtons = () => {
    const firstDepthSubmenus = this.menuRoot.querySelectorAll<HTMLElement>(".depth-1");

    firstDepthSubmenus.forEach((submenu: HTMLElement) => {
      const backButton = submenu.querySelector(".top-level-back") as HTMLButtonElement;
      backButton &&
        backButton.addEventListener("click", () => {
          submenu?.parentElement && submenu?.parentElement.classList.remove("top-level-slide-in");
          gsap.to(submenu?.parentElement, { duration: 0.2, translateX: "100%" });
        });
    });
  };

  initShowSubmenuButtons = () => {
    const liWithChildren = this.menuRoot.querySelectorAll<HTMLElement>(".submenu-list > li.has-children");

    liWithChildren.forEach((item: HTMLElement) => {
      const showSubmenuButton = item.querySelector(".show-submenu") as HTMLButtonElement;
      const submenu = item.querySelector(".submenu") as HTMLElement;
      showSubmenuButton &&
        showSubmenuButton.addEventListener("click", () => {
          submenu.classList.add("slide-in");
          gsap.set(submenu, { zIndex: 0 });
          gsap.to(submenu, { duration: 0.2, translateX: "0%" });
        });
    });
  };

  initBackButtons = () => {
    const submenuList = this.menuRoot.querySelectorAll<HTMLElement>(".submenu:not(.depth-1)");

    submenuList.forEach((list: HTMLElement) => {
      const backButton = list.querySelector(".back") as HTMLButtonElement;
      backButton &&
        backButton.addEventListener("click", () => {
          list.classList.remove("slide-in");
          gsap.to(list, {
            duration: 0.2,
            translateX: "100%",
            onComplete: () => {
              gsap.set(list, { zIndex: -1 });
            },
          });
        });
    });
  };

  openMenu = () => {
    disableScroll();
    gsap.to(this.menuRoot, { duration: 0.2, translateX: "0%" });
    gsap.to(this.blackout, { duration: 0.2, autoAlpha: 1 });
  };

  hideMenu = () => {
    gsap.to(this.menuRoot, { duration: 0.2, translateX: "100%" });
    gsap.to(this.blackout, { duration: 0.2, autoAlpha: 0 });

    const slideInSubmenus = this.menuRoot.querySelectorAll<HTMLElement>(".slide-in");
    const topLevelSlideInSubmenus = this.menuRoot.querySelectorAll<HTMLElement>(".top-level-slide-in");

    slideInSubmenus.forEach((submenu: HTMLElement) => {
      submenu.classList.remove("slide-in");
      gsap.to(submenu, { duration: 0.2, translateX: "100%", zIndex: -1 });
    });

    topLevelSlideInSubmenus.forEach((submenu: HTMLElement) => {
      submenu.classList.remove("top-level-slide-in");
      gsap.to(submenu, { duration: 0.2, translateX: "100%" });
    });
    enableScroll();
  };

  destroy = async () => {};
}

export default MobileMenu;
